import _ from "lodash";
import { DraftLoadType, MatDetail, PlanningItem, ReleaseDraft, ReleaseDraftData, Summary } from ".";

export interface PlanInfo {
    sales_org: string;
    sales_office: string;
    delivering_plant: string;
    route: string;
    planningDate: Date;
    planMode:string;
    bufferValues:any;
    planningData:PlanningItem[];
    matDetails:MatDetail[];
    adjestedMaterials:any;
    adjstCases:any;
    zeroload:boolean;
  }


  export function generateLoadDraft(planInfo: PlanInfo){
    // console.log("Clicked Save as Draft") ;
 
     const truckLoadState:ReleaseDraft[]=[];
     const customerLoadState:ReleaseDraft[]=[]; 
     
     //const stateInstance=stateObj?stateObj:_.cloneDeep(state);

     const isZeroLoad:boolean = planInfo?planInfo.zeroload:false;
     const {summary,planningItems} = generateSummary(planInfo);
 
     summary.forEach(summaryItem => {
       const draftItem: ReleaseDraft = {
         sales_org: planInfo.sales_org,
         sales_office: planInfo.sales_office,
         delivering_plant: planInfo.delivering_plant,
         route: planInfo.route,
         load_date: planInfo.planningDate,
         customer_num: '' ,
         equipment_num: '',
         ftc: false,
         online:false,
         zeroload:isZeroLoad,
         draft_load_type: DraftLoadType.TRUCKLOAD,
         material_num: summaryItem.materialNum,
         qty:summaryItem.totalUnits,
         bfr_adj_qty:summaryItem.adjustedUnits,
         adj_cs:summaryItem.matAdjExtaCS,
         extra_cs:summaryItem.adjstCS,
         clear_load:summaryItem.clearLoad,
         total_cs:summaryItem.totalReleaseCS,
         consignment:0,
         average_consumption:0,
         refill_quantity:0,
         delivery_type:0,
         conv_factor:getMatConv(planInfo?.matDetails,summaryItem.materialNum)
       };
       truckLoadState.push(draftItem);
     });
 
     planningItems.forEach(planningItem => {
       var deliveryType = 0;
       if (planningItem.activity === "PREM") {
         deliveryType = 1;
       }
       if (planningItem.activity === "DISP") {
         deliveryType = 2;
       }
       // equipment is in NOPH already? Don't create ticket and backend flips it back to NORM
       if (planningItem.equipmentStatus === "NOPH") {
         deliveryType = 0;
       }
 
       planningItem.details.forEach(planningItemDetail => {
         const draftItem: ReleaseDraft = {
           sales_org: planInfo?.sales_org,
           sales_office: planInfo.sales_office,
           delivering_plant: planInfo.delivering_plant,
           route: planInfo.route,
           load_date: planInfo.planningDate,
           customer_num: planningItem.customerNum ,
           equipment_num: planningItem.equipmentNum,
           ftc: planningItem.ftc,
           online:planningItem.online?true:false,
           zeroload:isZeroLoad,
           draft_load_type: DraftLoadType.CUSTOMERLOAD,
           material_num: planningItemDetail.material_num,
           qty:planningItemDetail.refill_qty,
           bfr_adj_qty:0,
           adj_cs:0,
           extra_cs:0,
           clear_load:false,
           total_cs:0,
           consignment:planningItemDetail.consignment,
           average_consumption:planningItemDetail.average_consumption,
           refill_quantity:planningItemDetail.refill_qty,
           delivery_type:deliveryType,
           conv_factor:getMatConv(planInfo?.matDetails,planningItemDetail.material_num)
         };
         customerLoadState.push(draftItem);
       });
     });
 
     const releaseDraftData: ReleaseDraftData = {
       salesOrg: planInfo.sales_org,
       salesOffice:planInfo.sales_office,
       deliveryPlant: planInfo.delivering_plant,
       route: planInfo.route,
       loadDate: planInfo.planningDate,
       truckLoadState: truckLoadState,
       customerLoadState: customerLoadState
     };
 
     
    //  let releaseDraftState:ReleaseDraft[]=truckLoadState.concat(customerLoadState);
     //console.log(releaseDraftState);
     //send this data to save release draft api
     return releaseDraftData;   
   };
    

    const generateSummary = (planInfo: PlanInfo) => {
        const PM_DYN = "DYNAMIC";
        const PM_STATIC = "STATIC";
        const planningDataObj =_.cloneDeep(planInfo.planningData);
        const planningItems = planningDataObj.filter(
          (elem) => elem.status === "S" && elem.nextDeliveryAct === planInfo.planningDate.toISOString().split("T")[0]
        );
        var summary: Summary[] = [];
       // if (planMode != PM_DYN) {
          summary = updateSummary(planningItems,planInfo);
       // }
        summary = handleAdjustedMaterials(summary,planInfo.adjestedMaterials,planInfo.adjstCases);
        return {summary,planningItems};
  
      }
  

    const updateSummary = (items: PlanningItem[],planInfo: PlanInfo): Summary[] => {
        var summaryMap = new Map<string, number>();
        const bufferMeta: any = {};
        for (var i = 0; i < items.length; i++) {
          const item = items[i];
          for (var j = 0; j < item.details.length; j++) {
            const mat = item.details[j];
            if (item.activity === "NORM" || item.activity === "INIT" || item.equipmentStatus === "NOPH") {
              if (summaryMap.has(mat.material_num)) {
                var totalUnits = summaryMap.get(mat.material_num) || 0;
                totalUnits += mat.refill_qty;
                summaryMap.set(mat.material_num, totalUnits);
                if(item?.ftc){
                  let ftcRefillQty = bufferMeta[mat.material_num]?.ftcRefilQty ?? 0
                  ftcRefillQty += mat.refill_qty
                  bufferMeta[mat.material_num] = {
                    ...bufferMeta[mat.material_num],
                    ftcRefilQty : ftcRefillQty
                  }
                }else if(item?.online){
                  let online = bufferMeta[mat.material_num]?.onlineRefilQty ?? 0
                  online += mat.refill_qty
                  bufferMeta[mat.material_num] = {
                    ...bufferMeta[mat.material_num],
                    onlineRefilQty : online
                  }
                }else{
                  let offline = bufferMeta[mat.material_num]?.offlineRefilQty ?? 0
                  offline += mat.refill_qty
                  bufferMeta[mat.material_num] = {
                    ...bufferMeta[mat.material_num],
                    offlineRefilQty : offline
                  }
                }
                
              } else {
                summaryMap.set(mat.material_num, mat.refill_qty);
                bufferMeta[mat.material_num] = {
                  material_num: mat.material_num,
                  material_num_short: parseInt(mat.material_num).toString(),
                };
                if(item?.ftc){
                  bufferMeta[mat.material_num] = {
                    ...bufferMeta[mat.material_num],
                    ftcRefilQty : mat.refill_qty
                  }
                }else if(item?.online){
                  bufferMeta[mat.material_num] = {
                    ...bufferMeta[mat.material_num],
                    onlineRefilQty : mat.refill_qty
                  }
                }else{
                  bufferMeta[mat.material_num] = {
                    ...bufferMeta[mat.material_num],
                    offlineRefilQty : mat.refill_qty
                  }
                }
              }
            }
          }
        }
        // console.log("🚀 ~ file: Release.tsx ~ line 282 ~ Release ~ bufferMeta", bufferMeta);
    
        const matnrs = Array.from(summaryMap.keys());
        var summaryItems = new Array<Summary>();
        for (var i = 0; i < matnrs.length; i++) {
          const matnr = matnrs[i];
          const matDetail: MatDetail = (planInfo.matDetails.find((elem) => elem.materialNum === matnr))!;
          var matDesc = "";
          const refillQty = summaryMap.get(matnr) || 0;
          const units =  Math.ceil(refillQty);
          const adjusted: number = calculateAdjustedLoad(bufferMeta[matnr], planInfo);
          var cs = 0;
          var actcs = 0;
          if (matDetail) {
            matDesc = matDetail.description;
            cs = Math.ceil((adjusted / matDetail.denominator) * matDetail.numerator);
            actcs = Math.ceil((units / matDetail.denominator) * matDetail.numerator);
          }
          if (cs === 0) {
            cs = 1;
            actcs = 1;
          }
          if (cs < 0) {
            cs = 0;
            actcs = 0;
          }
          var summaryItem: Summary = {
            materialNum: matnr,
            description: matDesc,
            totalUnits: refillQty,
            adjustedUnits: adjusted,
            totalCS: cs,
            act_cases: actcs,
            totalReleaseCS: cs,
            matAdjExtaCS: 0,
            adjstCS: 0,
            clearLoad: false,
          };
          summaryItems.push(summaryItem);
          //console.log("🚀 ~ file: Release.tsx ~ line 315 ~ Release ~ summaryItem", summaryItem);
        }
        summaryItems.sort(function (a, b) {
          var textA = a.description.toUpperCase();
          var textB = b.description.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        return summaryItems;
      };


      const calculateAdjustedLoad = (matDetails: any, planInfo:PlanInfo) => {
        let res = 0
        const onlineBuffer = getBuffer(matDetails, 'online', planInfo)
        const offlineBuffer = getBuffer(matDetails, 'offline', planInfo)
        if(matDetails?.ftcRefilQty){
          res += matDetails?.ftcRefilQty 
        }
        if(matDetails?.onlineRefilQty){
          res += (matDetails?.onlineRefilQty) + (matDetails?.onlineRefilQty * (onlineBuffer / 100))
        }
        if(matDetails?.offlineRefilQty){
          res += (matDetails?.offlineRefilQty) + (matDetails?.offlineRefilQty * (offlineBuffer / 100))
        }
      //console.log('🚀 ~ file: Release.tsx ~ line 320 ~ calculateAdjustedLoad ~ matDetails', matDetails)
      return Math.ceil(res)
      };


      
  const getBuffer = (matDetails: any, type: string, planInfo:PlanInfo) => {
    const bufferValues =  planInfo&&planInfo.bufferValues&&Object.keys(planInfo.bufferValues).length > 0 ? planInfo.bufferValues : []

    // const selectedRoute =state.selectedRoute;
    // const selectedDeliveryPlant=state.selectedDeliveryPlant;

    const selectedRoute = planInfo.route;
    const selectedDeliveryPlant= planInfo.delivering_plant;

    const BUFFER_LEVEL_MATERIAL=3;
    const BUFFER_LEVEL_ROUTE=2;
    const BUFFER_LEVEL_PLANT=1;
    const BUFFER_LEVEL_ALL=0;

    const selMaterialBufferList=bufferValues[matDetails?.material_num_short];
    if(selMaterialBufferList&&selMaterialBufferList?.length > 0){
      let buffer=0;
      let bufferApplied =false;
      for (let index = 0; index < selMaterialBufferList.length; index++) {
        const bufferItem = selMaterialBufferList[index];
        let bufferLevelPriority=0;
        if(bufferItem?.deliveryPlant === selectedDeliveryPlant){
          if(bufferItem?.route === selectedRoute){
              if(bufferLevelPriority<BUFFER_LEVEL_ROUTE){
                buffer = type === 'online' ? bufferItem?.onlineBuffer : bufferItem?.offlineBuffer;
                bufferLevelPriority=BUFFER_LEVEL_ROUTE;
                bufferApplied=true;
              }
            }else if (bufferItem?.route =="All") {
              if(bufferLevelPriority<BUFFER_LEVEL_PLANT){
                buffer = type === 'online' ? bufferItem?.onlineBuffer : bufferItem?.offlineBuffer;
                bufferLevelPriority=BUFFER_LEVEL_PLANT;
                bufferApplied=true;
              }
            }
        }
      }
      if(bufferApplied){
        return buffer;
      }
    }
    if(bufferValues?.All){
      const allVal = bufferValues?.All
      let buffer=0;
      let bufferLevelPriority=0;

      for (let index = 0; index < allVal.length; index++) {
        const item = allVal[index];
        if(item?.deliveryPlant === selectedDeliveryPlant){
          if(item?.route === selectedRoute){
            if(bufferLevelPriority<BUFFER_LEVEL_ROUTE){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_ROUTE;
            }
          }else if (item?.route =="All") {
            if(bufferLevelPriority<BUFFER_LEVEL_PLANT){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_PLANT;
            }
          }
        }else if(item?.deliveryPlant === 'All'){
          if(item?.route === selectedRoute){
            if(bufferLevelPriority<BUFFER_LEVEL_ROUTE){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_ROUTE;
            }
          }else if (item?.route =="All") {
            if(bufferLevelPriority<BUFFER_LEVEL_PLANT){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_PLANT;
            }
          }else{
            if(bufferLevelPriority<=BUFFER_LEVEL_ALL){
              buffer = type === 'online' ? item?.onlineBuffer : item?.offlineBuffer;
              bufferLevelPriority=BUFFER_LEVEL_ALL;
            }
          }
        }
      }
      return buffer
    }
    return 0
  }

  

  const handleAdjustedMaterials = (summary?: any, adjustedMaterials?: any, extraAdjustmentCases?: any ) => {
    const summaryObj: Summary[] = _.cloneDeep(summary);
    let newSummary: Summary[] = summaryObj;

    if (adjustedMaterials && adjustedMaterials.length > 0) {
      newSummary = summaryObj.map((item: any, row: any) => {
        const summaryItem: Summary = {
          materialNum: item.materialNum,
          description: item.description,
          totalUnits: item.totalUnits,
          adjustedUnits: item.adjustedUnits,
          totalCS: item.totalCS,
          act_cases: item.act_cases < 0 ? 0 : item.act_cases,
          totalReleaseCS: item.totalCS < 0 ? 0 : item.totalCS,
          matAdjExtaCS: 0,
          adjstCS: 0,
          clearLoad: false,
        };
        const adjustedItem = adjustedMaterials.find((mat: any) => item.materialNum === mat.material_num);
        let adjstCSVal = extraAdjustmentCases.get(item.materialNum);
        adjstCSVal = adjstCSVal ? adjstCSVal : 0;
        if (adjustedItem) {
          //if(isDateWithIn(adjustedItem.start_date,adjustedItem.end_date,props.data.planningDate)){
          if (adjustedItem.clear_load) {
            summaryItem.clearLoad = true;
            summaryItem.matAdjExtaCS = 0;
            summaryItem.totalCS = 0;
            summaryItem.totalReleaseCS = 0;
          } else {
            summaryItem.matAdjExtaCS = adjustedItem.quantity;
            summaryItem.adjstCS = adjstCSVal;
            //const updatedTotalCS =item.totalCS+adjustedItem.quantity;
            //summaryItem.totalCS=updatedTotalCS>=0?updatedTotalCS:0;
            summaryItem.totalCS = item.totalCS;
            let releaseCSTotal = item.totalCS + adjstCSVal + adjustedItem.quantity;
            if (releaseCSTotal < 0) {
              releaseCSTotal = 0;
            }
            summaryItem.totalReleaseCS = releaseCSTotal;
          }
          //}
        }
        return summaryItem;
      });

      for (const adjustedItem of adjustedMaterials) {
        let adjstCSVal = extraAdjustmentCases.get(adjustedItem.materialNum);
        adjstCSVal = adjstCSVal ? adjstCSVal : 0;
        if (!summaryObj.some((summaryItem) => adjustedItem.material_num === summaryItem.materialNum)) {
          let totalReleaseCS = !adjustedItem.clear_load ? adjustedItem.quantity + adjstCSVal : 0;
          if (totalReleaseCS < 0) {
            totalReleaseCS = 0;
          }
          newSummary.push({
            materialNum: adjustedItem.material_num,
            description: adjustedItem.description.description,
            totalUnits: 0,
            adjustedUnits: 0,
            totalCS: 0,
            act_cases:0,
            totalReleaseCS,
            matAdjExtaCS: !adjustedItem.clear_load ? adjustedItem.quantity : 0,
            adjstCS: adjstCSVal ? adjstCSVal : 0,
            clearLoad: adjustedItem.clear_load,
          });
        }
      }
      newSummary = handleExtraAdjstCases(newSummary, extraAdjustmentCases);

    } else {
      // Handle Manual Adjusted Extra Cases
      newSummary = handleExtraAdjstCases(newSummary, extraAdjustmentCases);
    }
    return newSummary;
  };

  const handleExtraAdjstCases = (newSummary: any, extraAdjustmentCases: Map<any, any>) => {
    newSummary.map((item: any, row: any) => {
      let adjstCSVal = extraAdjustmentCases?.get(item.materialNum);
      adjstCSVal = adjstCSVal ? adjstCSVal : 0;
      item.adjstCS = adjstCSVal;
      let releaseTotalCS = item.totalCS + adjstCSVal + item.matAdjExtaCS;
      if (releaseTotalCS < 0) {
        releaseTotalCS = 0;
      }
      item.totalReleaseCS = releaseTotalCS;
      return item;
    });
    return newSummary;
  };

  const getMatConv = (matDetails:any,matnr: string): number => {
    var factor = 1;
    const matDetail:any = matDetails.find((elem:any) => elem.materialNum === matnr);
    if (matDetail && matDetail.denominator && matDetail.numerator) {
      factor = matDetail.denominator / matDetail.numerator;
    }
    return factor;
  };

